/**
 * Holds the optional-MFA grace state surfaced by `/auth/login` when
 * `twoFactorGraceDaysRemaining > 0`: the user is fully logged in but should be
 * nudged to enrol. Drives the dismissible banner in the authenticated layout.
 *
 * In memory only — like the enrolment token it carries. A hard refresh drops it
 * (the banner reappears on the next login), which keeps the short-lived
 * `enrolmentToken` out of persistent storage.
 */
export interface GraceMfaState {
  daysRemaining: number;
  /** Short-lived token to start enrolment when the user clicks "Enable now". */
  enrolmentToken?: string;
}

let grace: GraceMfaState | null = null

export const setGraceMfa = (value: GraceMfaState): void => {
  grace = value
}

export const getGraceMfa = (): GraceMfaState | null => grace

export const clearGraceMfa = (): void => {
  grace = null
}
